module.exports = __webpack_public_path__ + "static/media/RoRo-login.f3ed4708.png";